type DatedShow = { id: string; show_id: string; broadcast_date: string | null };
function dateKey(date: Date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function currentWeek(now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  start.setDate(start.getDate() - ((start.getDay() + 6) % 7));
  const end = new Date(start);
  end.setDate(end.getDate() + 7);
  const last = new Date(end);
  last.setDate(last.getDate() - 1);
  return { start: dateKey(start), end: dateKey(end), last: dateKey(last) };
}
export function weeklyShows<T extends DatedShow>(
  episodes: T[],
  now = new Date(),
): T[] {
  const week = currentWeek(now);
  const seen = new Set<string>();
  return episodes
    .filter(
      (ep) =>
        ep.broadcast_date &&
        ep.broadcast_date.slice(0, 10) >= week.start &&
        ep.broadcast_date.slice(0, 10) < week.end,
    )
    .sort(
      (a, b) =>
        b.broadcast_date!.localeCompare(a.broadcast_date!) ||
        a.id.localeCompare(b.id),
    )
    .filter((ep) => {
      if (seen.has(ep.show_id)) return false;
      seen.add(ep.show_id);
      return true;
    });
}
export function wheelShows<T extends DatedShow>(
  episodes: T[],
  now = new Date(),
): T[] {
  const current = weeklyShows(episodes, now);
  const seen = new Set(current.map((ep) => ep.show_id));
  const remaining = [...episodes]
    .sort(
      (a, b) =>
        (b.broadcast_date || "").localeCompare(a.broadcast_date || "") ||
        a.id.localeCompare(b.id),
    )
    .filter((ep) => {
      if (seen.has(ep.show_id)) return false;
      seen.add(ep.show_id);
      return true;
    });
  return [...current, ...remaining];
}
export function wheelDelta(target: number, current: number, count: number) {
  if (!count) return 0;
  const forward = (((target - current) % count) + count) % count;
  return forward > count / 2 ? forward - count : forward;
}
export function wheelSlots(turn: number, count: number) {
  if (!count) return [];
  const offsets = count === 1 ? [0] : [-3, -2, -1, 0, 1, 2, 3];
  return offsets.map((offset) => ({
    slot: turn + offset,
    index: (((turn + offset) % count) + count) % count,
    offset,
    visible: Math.abs(offset) <= 1 && (count > 2 || offset <= 0),
  }));
}
